import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73385636"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-row"
}
const _hoisted_2 = { class: "form-cell" }
const _hoisted_3 = {
  key: 0,
  class: "text-orange-600 mt-2"
}
const _hoisted_4 = { class: "form-row" }
const _hoisted_5 = { class: "form-cell flex-1" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "form-cell flex-none" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-cell flex-none" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import HoForm from '@/components/form/ho-form.vue';
import HoText from '@/components/form/ho-text.vue';
import HoSelect from '@/components/form/ho-select.vue';
import Toggle from '@/components/form/toggle.vue';
import { PLAN_NAMES } from '@/constants/organization';
import IOrganization, { ICreateOrganizationData, IUpdateOrganizationData } from '@/interfaces/organizations/iOrganization';
import { getValidators, ValidationField } from './validations';
import { getActiveChangeWarningKey } from './utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
	loading: Boolean,
	editMode: Boolean,
	organizationData: {
		type: Object as () => IOrganization,
	},
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const localization = useI18n();

const validators = getValidators(localization.t);

const props = __props;

const emit = __emit;

const planOptions = PLAN_NAMES.map((p) => ({ label: p, value: p }));

const formData = ref({
	name: props.organizationData?.name ?? '',
	planName: props.organizationData?.planName ?? PLAN_NAMES[0],
	maxCompanies: (props.organizationData?.maxCompanies ?? '') as string | number,
	active: props.organizationData?.active ?? true,
});

const validState = ref<{ [key in ValidationField]: boolean }>({
	name: !!props.organizationData?.name,
	maxCompanies: !!props.organizationData?.maxCompanies,
});

const activeWarningKey = computed(() =>
	props.editMode && props.organizationData
		? getActiveChangeWarningKey(props.organizationData.active, formData.value.active)
		: null
);

const isValid = computed(() => !props.loading && validState.value.name && validState.value.maxCompanies);

const handleCancel = () => { emit('onClose'); };

const handleSave = () => {
	const data: ICreateOrganizationData = {
		name: formData.value.name.trim(),
		planName: formData.value.planName,
		maxCompanies: Number(formData.value.maxCompanies),
	};

	if (props.editMode && props.organizationData) {
		const updateData: IUpdateOrganizationData = { ...data, id: props.organizationData.id, active: formData.value.active };
		emit('onClose', updateData);
		return;
	}

	emit('onClose', data);
};

const handleActiveChange = (value: boolean) => {
	formData.value.active = value;
};

const handleValidationStateChange = (fieldKey: ValidationField, value: boolean) => {
	validState.value[fieldKey] = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HoForm, {
    class: "form-gray mt-4",
    modelValue: formData.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData).value = $event)),
    disableAutocomplete: true,
    onOnOk: handleSave,
    onOnCancel: handleCancel,
    okButtonText: __props.loading ? _unref(localization).t('common.saving') : _unref(localization).t('common.save'),
    cancelButtonText: _unref(localization).t('common.cancel'),
    disableOk: !isValid.value
  }, {
    body: _withCtx(() => [
      (__props.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Toggle, {
                class: "mt-2 ml-0",
                label: _unref(localization).t('administration.organizations.form.active'),
                name: "organization-active",
                checked: __props.organizationData?.active,
                onOnChange: handleActiveChange
              }, null, 8, ["label", "checked"]),
              (activeWarningKey.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(localization).t(activeWarningKey.value)), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HoText, {
            label: _unref(localization).t('administration.organizations.form.name'),
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
            "disable-autocomplete": true,
            validation: _unref(validators).name,
            modelKey: "name",
            onOnValidStateChange: handleValidationStateChange
          }, null, 8, ["label", "modelValue", "validation"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(HoSelect, {
            label: _unref(localization).t('administration.organizations.form.plan'),
            modelValue: formData.value.planName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.planName) = $event)),
            modelKey: "planName",
            "select-options-list": _unref(planOptions)
          }, null, 8, ["label", "modelValue", "select-options-list"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(HoText, {
            label: _unref(localization).t('administration.organizations.form.max-companies'),
            modelValue: formData.value.maxCompanies,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.maxCompanies) = $event)),
            "disable-autocomplete": true,
            validation: _unref(validators).maxCompanies,
            modelKey: "maxCompanies",
            onOnValidStateChange: handleValidationStateChange
          }, null, 8, ["label", "modelValue", "validation"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "okButtonText", "cancelButtonText", "disableOk"]))
}
}

})